import { useTranslation } from 'react-i18next'
import { useToggleTicketFeatureActiveMutation } from '@/entities/ticket-feature'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface TicketFeatureStatusToggleProps {
  featureId: string
  isActive: boolean
}

export function TicketFeatureStatusToggle({ featureId, isActive }: TicketFeatureStatusToggleProps) {
  const { t } = useTranslation()
  const mutation = useToggleTicketFeatureActiveMutation()

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={mutation.isPending}
        confirmEnableTitle={t('ticketFeature.enableConfirm', {
          defaultValue: 'Activate this ticket feature?',
        })}
        confirmDisableTitle={t('ticketFeature.disableConfirm', {
          defaultValue: 'Deactivate this ticket feature?',
        })}
        onConfirmed={async () => {
          try {
            await mutation.mutateAsync({ id: featureId, isActive: !isActive })
            showToast.success(
              t('ticketFeature.statusUpdateSuccess', {
                defaultValue: 'Ticket feature status updated',
              }),
            )
          } catch (error) {
            showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
          }
        }}
      />
    </div>
  )
}
